export class Routes {
  static LICENSES = "/licenses/";
  static REPORTS = "/reports/";
  static TARGETS = "/profiles/targets/";
  static TASKS = "/tasks/";
  static VULNERABILITY_EARLY_WARNING = "/api/tvm/";
  static TICKETS = "/api/tickets/";
  static CARD_PROTECTION = "/cardp/";
}
